import loadView from "@/utils/load-view";

const routes = [
    {
        path: "/userlist", // Legacy route
        redirect: "/feedback/list/all",
    },
    {
        path: "/feedback",
        redirect: "/feedback/list/all",
    },
    {
        path: "/feedback/list/:view",
        name: "Feedback",
        component: loadView("Feedback"),
        props: true,
        meta: {
            authRequired: true,
            resolvers: [
                // Feedback list views
                to => {
                    if (["all", "my"].includes(to.params.view)) {
                        return {
                            type: "feedback/feedback/getList",
                            payload: { filter: to.params.view },
                        };
                    }
                },
                to => {
                    if (["all", "my"].includes(to.params.view)) {
                        return { type: "feedback/request/getList" };
                    }
                },

                // Analytics resolvers
                (to, from) => {
                    // resolver should only get triggered on initial load and not when updating the url
                    // with query parameters
                    if (to.params.view === "stats" && from.path !== "/feedback/list/stats") {
                        return { type: "teams/local/getList", payload: { filter: "manager" } };
                    }

                    return null;
                },
            ],
        },
        children: [
            {
                path: "/feedback/list/:view/details/:id",
                name: "FeedbackDetails",
                component: loadView("FeedbackDetails"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        to => ({
                            type: "feedback/feedback/getDetails",
                            payload: { id: to.params.id },
                        }),
                        to => ({
                            type: "feedback/feedback/read",
                            payload: { id: to.params.id },
                        }),
                    ],
                },
            },
            {
                path: "/feedback/list/:view/request",
                name: "FeedbackRequest",
                component: loadView("FeedbackRequest"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        () => ({ type: "skills/getSkills", payload: { showAll: false } }),
                        to => {
                            if (to.query.to) {
                                return {
                                    type: "users/details/get",
                                    payload: { id: to.query.to },
                                };
                            }
                        },
                        () => ({
                            type: "users/list/get",
                            payload: {
                                userFilter: { include: { admin: [{ _id: "directTeam" }] } },
                            },
                        }),
                    ],
                },
            },
            {
                path: "/feedback/list/:view/create",
                name: "FeedbackCreate",
                component: loadView("FeedbackCreate"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        to => {
                            // From feedback request
                            if (to.query.requestedBy) {
                                return {
                                    type: "skills/getListForUser",
                                    payload: { userId: to.query.requestedBy },
                                };
                            }

                            // From side menu
                            if (to.query.to) {
                                return {
                                    type: "skills/getListForUser",
                                    payload: { userId: to.query.to },
                                };
                            }
                        },
                        to => {
                            if (to.query.requestedBy) {
                                return {
                                    type: "feedback/request/get",
                                    payload: { senderId: to.query.requestedBy },
                                };
                            }
                        },
                        to => {
                            // From side menu
                            // Note that for feedback requests, the user's info is already returned by the API
                            if (to.query.to) {
                                return {
                                    type: "users/details/get",
                                    payload: { id: to.query.to },
                                };
                            }
                        },
                        () => ({
                            type: "users/list/get",
                            payload: {
                                userFilter: { include: { admin: [{ _id: "directTeam" }] } },
                            },
                        }),
                    ],
                },
            },
            {
                path: "/feedback/list/:view/create/praise",
                name: "FeedbackCreatePraise",
                component: loadView("FeedbackCreatePraise"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        () => ({ type: "feedback/badges/getList" }),
                        to => {
                            if (to.query.to) {
                                return {
                                    type: "users/details/get",
                                    payload: { id: to.query.to },
                                };
                            }
                        },
                        () => ({
                            type: "users/list/get",
                            payload: {
                                userFilter: { include: { admin: [{ _id: "directTeam" }] } },
                            },
                        }),
                    ],
                },
            },
        ],
    },
];

export default routes;
